<template>
<v-row :class="['im-result', getClass()]" align="center" no-gutters>
    <v-col class="py-0" md="2" v-if="$vuetify.breakpoint.mdAndUp" align-self="center">
        <div style="width: 140px;">
            <div :class="[$vuetify.breakpoint.mdAndUp?'text-center':'text-left','pa-1 important font-weight-bold d-flex']">
                <v-avatar v-if="item.channel" size="24" class="mx-1" tile>
                    <img :src="getLogo()">
                </v-avatar>
                <span>{{ item.external_id }}</span>
            </div>
            <div :class="[$vuetify.breakpoint.mdAndUp?'text-center':'text-left','pa-1 detail']">
                {{ getLocalDate(item.created_at) }}
            </div>
        </div>
    </v-col>
    <v-col class="py-0" md="3" cols="6">
        <div :class="{'pl-2':$vuetify.breakpoint.smAndDown}">
            <div class="regular font-weight-bold text-truncate">
                {{ item.customer.first_name }} {{ item.customer.last_name }}
            </div>
            <div class="detail text-truncate">
                {{ item.customer.contact.email }}
            </div>
            <div class="detail">
                {{ item.customer.contact.phone }}
            </div>
        </div>
    </v-col>
    <v-col class="py-0" md="7" cols="6">
        <v-row no-gutters>
            <v-col class="py-0" md="5" cols="12" v-if="$vuetify.breakpoint.mdAndUp">
                <div class="py-1" v-for="(room, index) in unique_rooms" :key="index">
                    <div class="regular font-weight-bold text-truncate">
                        {{ room.count }} X {{ room.room_name }}
                        <span v-if="room.status == 'cancelled'&&item.status!='cancelled'">
                            <v-chip class="ma-0 py-0 px-1" color="red" small text-color="white" style="height:18px">cancelled by guest</v-chip>
                        </span>
                    </div>
                    <div v-if="$vuetify.breakpoint.mdAndUp" class="detail">{{ room.rate_plan_name }}</div>
                </div>
            </v-col>
            <v-col class="py-0" md="3" cols="6" align-self="center">
                <div class="align-center fill-height justify-center text-center">
                    <im-period :check_in="item.check_in" :check_out="item.check_out" />
                    <div v-if="$vuetify.breakpoint.smAndUp" class="faded">{{item.pax.adults}} adulti<span> + {{ getChildren(item.pax) }} copii</span></div>
                </div>
            </v-col>
            <v-col class="py-0" md="4" cols="6" align-self="center">
                <v-row no-gutters>
                    <v-col class="py-0" md="6" cols="12">
                        <div class="text-right">
                            <im-price :price="item.pricing.total" :fontSize="$vuetify.breakpoint.smAndDown? '12': '14'" :currency="item.pricing.currency" />
                        </div>
                    </v-col>
                    <v-col class="py-0" md="6" cols="12" v-if="$vuetify.breakpoint.mdAndUp" :class="[$vuetify.breakpoint.smAndDown? 'detail': 'regular']">
                        <div :class="[$vuetify.breakpoint.smAndDown? 'text-truncate ': 'text-center']">
                            <div v-if="item.channel == 'Q-Travel'"><span>Platita la agentie</span></div>
                            <div v-else>Plata la hotel</div>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-col>
</v-row>
</template>

<script>
import IMPeriod from '../../small-components/IMPeriod.vue';
import IMPrice from '../../small-components/IMPrice.vue';
import Booking from '../../../assets/bookingcom.svg';
import BookingEngine from '../../../assets/booking-engine-logo.svg';
import CHR from '../../../assets/christian_tour.png';
import Expedia from '../../../assets/expedia.png';
import HLR from '../../../assets/helloromania.png';

export default {
    name: `reservations`,
    components: {
        'im-period': IMPeriod,
        'im-price': IMPrice,
    },
    props: {
        item: Object,
    },

    data: () => {
        return {
            hello_romania: HLR,
            q_travel: CHR,
            booking: Booking,
            booking_engine: BookingEngine,
            expedia: Expedia,
            comments_reservation: [],
            unique_rooms: [{
                id: 0,
                index_room: 0,
                show: false,
                count: 0
            }],
            loading_item: false,
            show_more: false,
            show_total: true
        }
    },

    watch: {
        item: {
            handler() {
                this.uniqueRooms();
            }
        },
    },
    created() {
        this.uniqueRooms();
    },

    methods: {
        uniqueRooms() {
            let reservation = this.item;
            let rooms = [];
            let unique_room_id = [...new Set(reservation.rooms.map(item => item.room_type.id))];
            unique_room_id.forEach(function (item, index) {
                let abc = reservation.rooms.filter(room => room.room_type.id === item);
                let all_status = [...new Set(abc.map(item => item.status))];
                all_status.forEach(function (status_item) {
                    let unique_rate = [...new Set(abc.map(item => item.rate_plan.id))];
                    unique_rate.forEach(function (item_rate, index) {
                        let unique_room = {
                            id: item,
                            index_room: null,
                            room_name: null,
                            rate_plan_name: null,
                            show: false,
                            status: status_item,
                            count: 0
                        };
                        reservation.rooms.forEach(function (abc_room, index_room) {
                            if(abc_room.room_type.id === item && abc_room.rate_plan.id === item_rate && abc_room.status == status_item) {
                                unique_room.count += 1;
                                unique_room.room_name = abc_room.room_type.name;
                                unique_room.rate_plan_name = abc_room.rate_plan.name;
                                unique_room.index_room = index_room;
                                unique_room.status = status_item;
                            }
                        });
                        if(unique_room.count) {
                            rooms.push(unique_room);
                        }
                    })
                });

            });
            this.unique_rooms = rooms;
        },

        getChildren(pax) {
            let children = pax.infants + pax.big_children + pax.small_children;
            return children
        },

        getLocalDate(value) {
            return this.$moment.utc(value)
                .local()
                .format('DD-MM-YYYY HH:mm:ss')
        },

        emitClick() {
            this.$emit('click');
        },

        getClass() {
            switch (this.item.status) {
            case 'booked':
                return 'im-result-success';
            case 'modified':
                return 'im-result-success';
            case 'no-show':
                return 'im-result-warning';
            case 'cancelled':
                return 'im-result-danger';
            default:
                return '';
            }
        },

        getLogo() {
            switch (this.item.channel) {
            case 'Hello-Romania':
                return this.hello_romania;
            case 'Q-Travel':
                return this.q_travel;
            case 'Booking':
                return this.booking;
            case 'Expedia':
                return this.expedia;
            case 'MementoBookings':
                return this.booking_engine;
            default:
                return null;
            }
        }

    },
}
</script>
<style lang="stylus">
.booked
    border-left: 5px solid #4CAF50

.no-show
    border-left: 5px solid #FFC107
    background-color: #FFF8E1

.canceled
    border-left: 5px solid #F44336
    background-color: #FFEBEE

</style>
